@if (data.header) {
  <h1 mat-dialog-title>{{data.header}}</h1>
}
<div class="dialog-content" mat-dialog-content>
  {{data.message}}
  @if (data?.subMessage) {
    <div class="sub-dialog-content" [innerHTML]="data.subMessage">
    </div>
  }
</div>
<div mat-dialog-actions align="end">
  @if (data.cancelBtnTxt) {
    <button mat-button [mat-dialog-close]="true" tabindex="1">
      {{data.confirmBtnTxt}}
    </button>
    @if (data.saveAndConfirmBtnTxt) {
      <button
        mat-button
        (click)="onSaveAndConfirmClick()"
        tabindex="2">
        {{data.saveAndConfirmBtnTxt}}
      </button>
    }
    <button mat-button color="accent" (click)="onNoClick()" tabindex="3">
      {{data.cancelBtnTxt}}
    </button>
  } @else {
    <button mat-button [mat-dialog-close]="true" tabindex="1">{{data.confirmBtnTxt}}</button>
  }

</div>